import React from 'react';
import { Col } from 'react-bootstrap';

export const Service = (props) => {
	const { image, text } = props;
	return (
		<Col className="default-service-item" md={4} sm={3} xs={12}>
			<div className="inner-box wow fadeIn" {...props}>
				<figure className="icon-box">
					<img src={require('../../../assets/images/services')[image]} alt={text} />
				</figure>
				<div className="text">{text}</div>
			</div>
		</Col>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Services/Service.js